import { defineCustomElement } from 'vue'
import AppCe from '@/components/product/WrapperRootProduct.ce.vue'

const customEl = defineCustomElement(AppCe)

customElements.define('product-info', customEl)
